import React, { useState } from 'react';
import { Box, TextField, Button, Typography } from '@mui/material';

const InviteUsers: React.FC = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState<string | null>(null);

    const handleInvite = async () => {
        try {
            // Simulate an API call to send an invite
            console.log('Inviting user with email:', email);
            setMessage('User invited successfully!');
        } catch (error) {
            console.error('Error inviting user:', error);
            setMessage('Failed to invite user.');
        }
    };

    return (
        <Box
            sx={{
                maxWidth: 400,
                margin: 'auto',
                mt: 8,
                p: 3,
                backgroundColor: '#fff',
                borderRadius: 2,
                boxShadow: 3,
            }}
        >
            <Typography variant="h5" sx={{ marginBottom: 3 }}>
                Invite a User
            </Typography>
            {message && (
                <Typography sx={{ color: message.includes('success') ? 'green' : 'red', mb: 2 }}>
                    {message}
                </Typography>
            )}
            <TextField
                label="User Email"
                variant="outlined"
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                sx={{ mb: 3 }}
            />
            <Button variant="contained" color="primary" fullWidth onClick={handleInvite}>
                Invite User
            </Button>
        </Box>
    );
};

export default InviteUsers;
